"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelSplit = void 0;
const camelSplit = (str) => str.replace(/([A-Z])/g, ' $1').trim();
exports.camelSplit = camelSplit;
//# sourceMappingURL=camelSplit.js.map